import { SelectCards } from 'components/Form/SelectCards';
import React, { Suspense } from 'react';
import { ClassroomsOrg } from '@teetsh/app/src/types/school';
import { useTranslation } from 'react-i18next';
import SplitFrIllustration from './assets/fr/split/Loadable';
import UnifiedFrIllustration from './assets/fr/unified/Loadable';
import SplitEnIllustration from './assets/en/split/Loadable';
import UnifiedEnIllustration from './assets/en/unified/Loadable';

interface Props {
  value: ClassroomsOrg;
  onChange: (v: ClassroomsOrg) => void;
}

function getUnifiedIllusration(locale: 'en' | 'fr') {
  if (locale === 'en') {
    return <UnifiedEnIllustration />;
  }
  return <UnifiedFrIllustration />;
}

function getSplitIllusration(locale: 'en' | 'fr') {
  if (locale === 'en') {
    return <SplitEnIllustration />;
  }
  return <SplitFrIllustration />;
}

export function ClassroomsOrgSettings(props: Props) {
  const { value, onChange } = props;
  const { t } = useTranslation(['common', 'schoolyearSettings']);
  return (
    <SelectCards
      direction="vertical"
      variant="outlined"
      value={value}
      onChange={onChange}
      options={[
        {
          value: 'unified',
          description: (
            <>
              {t('schoolyearSettings:schoolOrg.unifiedSubtitle2')}
              <br />
              {t('schoolyearSettings:schoolOrg.unifiedSubtitle1')}
            </>
          ),
          label: t('schoolyearSettings:schoolOrg.unifiedTitle'),
          illustration: (
            <Suspense fallback={null}>
              {getUnifiedIllusration(t('common:locale.short'))}
            </Suspense>
          ),
        },
        {
          value: 'split',
          description: (
            <>
              {t('schoolyearSettings:schoolOrg.splitSubtitle1')} <br />
              {t('schoolyearSettings:schoolOrg.splitSubtitle2')}
            </>
          ),
          label: t('schoolyearSettings:schoolOrg.splitTitle'),
          illustration: (
            <Suspense fallback={null}>
              {getSplitIllusration(t('common:locale.short'))}
            </Suspense>
          ),
        },
      ]}
    />
  );
}
